import {useZoneToStorePerformance} from "../hooks/operations";
import ZoneToStorePerformance from "./index";

export default function OperationsZoneToStorePerformance() {
    const { data: sortedData, isLoading } = useZoneToStorePerformance();

    return <ZoneToStorePerformance data={sortedData} isLoading={isLoading} />
}